module.exports = __webpack_public_path__ + "img/icon_market1.5fc008d1.91f8ffde.svg";